import { SignInButton } from "@clerk/clerk-react";
import './Login.css';

const Login = () => {
    return (
        <div className="login-container">
            <div className="login-box">
            <SignInButton mode="modal" className="login-content">
                <button >
                Sign in with Clerk
                </button>
                </SignInButton>
            </div>
        </div>
    )
}
export default Login